import React from "react";
import { CustomForm, CustomInput, CustomTextArea } from "../../shared/Input/AllInputs";
import EnquiryContainer from "./EnquiryContainer";
// import CustomImageInput from "../../shared/Input/CustomImageInput";
import { NewCustomViewImage } from "../../shared/Input/AllViewInputs";

const EnquiryForm = ({ type }) => {
    const { data } = EnquiryContainer();
    return (
        <>
            {/* style={type === "VIEW" ? {pointerEvents: "none"} : {}} */}
            <CustomForm >
                <CustomInput label="Full Name" name="fullName" data={data} />
                <CustomInput label="Email Address" name="email" data={data} disabled />
                <CustomInput label="Service Question" name="serviceQuestion" data={data} disabled />
                <CustomInput label="Phone Number" name="phoneNumber" data={data} disabled />
                <CustomInput label="Property Type" name="propertyType" data={data} disabled />
            </CustomForm>
            <CustomForm>
                {data?.files?.length && data?.files?.map((file) => {
                    return (
                        <NewCustomViewImage label={"files"} image={file} />
                    )
                })}

                <CustomTextArea label="Message" name="message" data={data} disabled />
            </CustomForm>
        </>
    );
};

export default EnquiryForm;
